import { KeyValue } from "@/main/models/common";
import { DynamicReportFilterValues, DynamicReportQueryRequest } from "@/main/models/request/dynamicReportRequest";
import { VariableTypeEnum } from "@/main/services/enum/VariableTypeEnum";
import { isNullUndefined } from "@/main/services/utils";
import { formatDateToISOString, getKeysIgnoreValidationsDate, validateFormDate } from "@/main/services/utilsDate";
import { IFilterDinamic, IFormFiltersDynamicExport } from "./modalExportDynamicReport";
import { DefaultValueParameterEnum } from "@/main/services/enum/DefaultValueParameterEnum";

export function formatParameters(dataFilterDinamic: IFilterDinamic): DynamicReportFilterValues | boolean {
	if (isNullUndefined(dataFilterDinamic.value) || dataFilterDinamic.value === "") return false;

	const isArrayValue = Array.isArray(dataFilterDinamic.value);
	const isDateValue = [VariableTypeEnum.Date, VariableTypeEnum.DateRange].includes(dataFilterDinamic.idVariableType);

	const isValidDate = (value: unknown): value is Date => value instanceof Date && !Number.isNaN(value.getTime());

	const formatVariableValue = (): string => {
		if (isNullUndefined(dataFilterDinamic.value)) return "";
		if (isDateValue && isValidDate(dataFilterDinamic.value))
			return formatDateToISOString(dataFilterDinamic.value as Date);
		if (isDateValue) return "";
		if (isArrayValue) return "";

		return dataFilterDinamic.value.toString();
	};

	const formatVariableRangeValue = (): string => {
		if (!isDateValue || !isValidDate(dataFilterDinamic.valueRange)) return "";

		return formatDateToISOString(dataFilterDinamic.valueRange);
	};

	return {
		guidDynamicReportVariable: dataFilterDinamic.guidDynamicReportVariable,
		variableValue: formatVariableValue(),
		variableRangeValue: formatVariableRangeValue(),
		values: isArrayValue ? (dataFilterDinamic.value as KeyValue[]).map((item) => item.key) : [],
	};
}

export function validateFormDynamicReport(data: IFormFiltersDynamicExport) {
	const hasFieldsDate = data.filtersDinamics.some(
		(item) => item.idVariableType === VariableTypeEnum.Date || item.idVariableType === VariableTypeEnum.DateRange,
	);

	if (hasFieldsDate) {
		const filterDataFieldsDate = data.filtersDinamics.filter((item) => item.idVariableType === VariableTypeEnum.Date);

		if (filterDataFieldsDate.length > 0) {
			filterDataFieldsDate.forEach((item) => {
				const dateValue = item.value as Date;
				const keysIgnoreValidationsDateSubmit = getKeysIgnoreValidationsDate(
					item.responseServer.mandatory,
					dateValue,
					dateValue,
				);
				validateFormDate(
					dateValue,
					dateValue,
					item.responseServer.maxAllowedRange ?? 9999999999,
					keysIgnoreValidationsDateSubmit,
				);
			});
		}

		const filterDataFieldsDateRange = data.filtersDinamics.filter(
			(item) => item.idVariableType === VariableTypeEnum.DateRange,
		);

		if (filterDataFieldsDateRange.length > 0) {
			filterDataFieldsDateRange.forEach((item) => {
				const dateValue = item.value as Date;
				const dateRangeValue = item.valueRange as Date;
				const keysIgnoreValidationsDateSubmit = getKeysIgnoreValidationsDate(false, dateValue, dateRangeValue);
				validateFormDate(
					dateValue,
					dateRangeValue,
					item.responseServer.maxAllowedRange ?? DefaultValueParameterEnum.FallbackRangeDate,
					keysIgnoreValidationsDateSubmit,
				);
			});
		}
	}
}

export function formatFrontEndToBackEndDynamicReport(
	guidDynamicReport: string,
	data: IFormFiltersDynamicExport,
): DynamicReportQueryRequest {
	const formattedParameters = data.filtersDinamics.map(formatParameters).filter(Boolean) as DynamicReportFilterValues[];

	const request: DynamicReportQueryRequest = {
		guidDynamicReport,
		parameters: formattedParameters,
	};

	return request;
}
